import React from "react";
import { Dropdown, Menu, Row, Image, Typography, Space, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";

const { Title } = Typography;

interface ProductListProps {
  lineItems?: {
    product?: {
      _id: string;
      img?: string;
      title?: string;
      description?: string;
      product: {
        _id: string;
        name: string;
        description: string;
      };
    };
    qty?: number;
    complements?: {
      _id: string;
      quantity: number;
      variant?: {
        title?: string;
        img?: string;
        product?: {
          name: string;
        };
      };
    }[];
    beverages?: {
      _id: string;
      quantity: number;
      variant?: {
        title?: string;
        img?: string;
        product?: {
          name: string;
        };
      };
    }[];
    extras?: {
      _id: string;
      quantity: number;
      variant?: {
        title?: string;
        img?: string;
        product?: {
          name: string;
        };
      };
    }[];
  }[];
}

const ProductList: React.FC<ProductListProps> = ({ lineItems }) => {
  const flattenLineItems = (lineItems: any[]) => {
    return lineItems?.flatMap((item) => [
      // Main product
      ...Array(item.qty).fill({
        productId: item?.product?.product?._id,
        name: item?.product?.product?.name + (item?.product?.title ? ` (${item?.product?.title})` : ""),
        image: item?.product?.img,
      }),
      // Complements
      ...(item.complements?.flatMap((complement: any) =>
        Array(complement.quantity).fill({
          productId: complement?._id,
          name: `${complement?.variant?.product?.name} (Complemento)`,
          image: complement.variant?.img,
        })) ?? []),
      // Beverages
      ...(item.beverages?.flatMap((beverage: any) =>
        Array(beverage.quantity).fill({
          productId: beverage?._id,
          name: `${beverage.variant?.product?.name} (Bebida)`,
          image: beverage.variant?.img,
        })) ?? []),
      // Extras
      ...(item.extras?.flatMap((extra: any) =>
        Array(extra.quantity).fill({
          productId: extra?._id,
          name: `${extra.variant?.product?.name} (Extra)`,
          image: extra.variant?.img,
        })) ?? []),
    ]);
  };

  const flattenedItems = flattenLineItems(lineItems || []);

  return (
    <Dropdown
      trigger={["click"]}
      overlay={
        <Menu
          mode="vertical"
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            maxWidth: "500px",
          }}
        >
          {flattenedItems.map((item, index) => (
            <Menu.Item key={`${item.productId}-${index}`}>
              <Row
                align="middle"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Image
                  src={item.image}
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: 15,
                    objectFit: "cover",
                  }}
                  preview={false}
                />
                <div style={{ marginLeft: 20,
                  flex: 1 }}>
                  <Title level={5} style={{ margin: 0 }}>
                    {item.name}
                  </Title>
                </div>
              </Row>
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <Button>
        <Space>
          Productos
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default ProductList;

